import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FacadeService } from 'src/app/core/services/facade.service';
import { Specialite } from 'src/app/shared/models/specialite';

@Component({
	selector: 'app-specialite-modal-detail',
	templateUrl: './specialite-modal-detail.component.html',
	styleUrls: ['./specialite-modal-detail.component.scss']
})
export class SpecialiteModalDetailComponent implements OnInit {
	NAME_PATTERN = '^[^0-9]+$';

	formEdit = new FormGroup({
		name: new FormControl('', [
			Validators.required,
			Validators.pattern(this.NAME_PATTERN),
			Validators.maxLength(32)
		])
	});

	specialite: Specialite;

	confirmDeleteModalRef: BsModalRef;

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked = false;

	constructor(
		public bsModalRef: BsModalRef,
		private facade: FacadeService,
		private modalService: BsModalService
	) {}

	ngOnInit(): void {
		this.formEdit.setValue({
			name: this.specialite ? this.specialite.name : null
		});
	}

	onSubmit() {
		this.isValidateButtonClicked = true;
		this.specialite.name = this.formEdit.get('name').value;
		this.facade.specialiteService.updateSpecialite(this.specialite).subscribe({
			next: (succ) => {
				// this.isValidateButtonClicked=false;
				this.bsModalRef.hide();
			},
			error: (err) => {
				this.isValidateButtonClicked = false;
			}
		});
	}

	deleteSpecialty(): void {
		this.facade.specialiteService
			.deleteSpecialite(this.specialite.id)
			.subscribe((_) => {
				this.modalService.hide();
				this.bsModalRef.hide();
			});
	}

	openModal(confirmDeleteTemplate: TemplateRef<any>): void {
		this.confirmDeleteModalRef = this.modalService.show(confirmDeleteTemplate);
	}

	delete() {
		this.facade.specialiteService
			.deleteSpecialite(this.specialite.id)
			.subscribe({
				next: (succ) => {
					this.modalService.hide();
					this.bsModalRef.hide();
				},
				error: (err) => {
					this.facade.toastService.createHttpErrorToast(
						err.error.response ? err.error.response : '',
						err.status
					);
				}
			});
	}

	get name() {
		return this.formEdit.get('name');
	}
}
